<template>
  <div class="contact">
    <div class="uk-container">
      <div class="uk-card uk-card-body">

        <div uk-grid class="uk-grid-large">
          <!-- PHOTO https://www.sejda.com/html-to-pdf -->
          <div class="uk-width-2-5@m">
            <img alt="Thomas Desfossez" src="../assets/thomas-desfossez-2019.jpg" class="uk-border-circle uk-width-1">
          </div>

          <!-- TITRE -->
          <div class="uk-width-3-5@m uk-flex uk-flex-column uk-flex-center">
            <h1 class="uk-margin-remove-bottom">Thomas Desfossez</h1>

            <p class="uk-margin-remove-top"><strong>Senior Front-End Web Developer</strong></p>

            <p class="uk-margin-small-bottom  uk-text-meta">
              <span class="uk-icon uk-margin-small-right" uk-icon="icon: world"></span>Français - Franco-Canadien 🍁
            </p>

            <p class="uk-margin-small-bottom  uk-margin-remove-top uk-text-meta">
              <span class="uk-icon uk-margin-small-right" uk-icon="icon: sign-out"></span> Sortie en 1987
            </p>

            <p class="uk-margin-remove-bottom uk-margin-remove-top uk-text-meta">
              <span class="uk-icon uk-margin-small-right" uk-icon="icon: location"></span> Neuville-Sur-Saône, 69250, FRANCE
            </p>
          </div>
        </div>

        <div uk-grid class="uk-grid-large">
          <!-- LEFT -->
          <div class="uk-width-2-5@m">
            <h2>
              Profil
            </h2>

            <p>
              Entre le Canada et l'Europe, j'ai développé pendant 10 années une expérience professionnelle dans les domaines du développement web, de la gestion de projet Agile et de l'architecture front-end.
            </p>

            <p>
              Je reste à l'affût des nouvelles pratiques et technologies dans le domaine du web. <br>
              J'applique mes connaissances en <strong>accessibilité</strong>, en <strong>gestion de projets</strong>, en <strong>développement front-end</strong> et en <strong>design</strong> sur l'ensemble de mes projets.
            </p>

            <hr class="uk-divider-icon">

            <h2 class="uk-margin-remove-top">
              Contact
            </h2>

            <p>
              <span class="uk-icon uk-margin-small-right" uk-icon="icon: mail"></span><a href="mailto:constraintsolver@gmail.com">constraintsolver@gmail.com</a>
            </p>

            <p>
              <span class="uk-icon uk-margin-small-right" uk-icon="icon: phone"></span> <a href="tel:+33675118441">+33675118441</a>
            </p>

            <p>
              <span class="uk-icon uk-margin-small-right" uk-icon="icon: desktop"></span> <a href="https://www.thomas-desfossez.com/#/" target="_blank">thomas-desfossez.com</a>
            </p>

            <p>
              <span class="uk-icon uk-margin-small-right" uk-icon="icon: linkedin"></span> <a href="https://linkedin.com/in/tdesfossez/" target="_blank">/tdesfossez</a>
            </p>

            <h2>
              Expertises 2019
            </h2>

            <ul class="uk-list">
              <li>
                ⭐⭐⭐⭐⭐
              </li>
              <li>
                HTML5
              </li>
              <li>
                SCSS / SASS / CSS3
              </li>
              <li>
                Accessibilité
              </li>
              <li>
                javaScript / ECMAScript 6/7...
              </li>
              <li>
                Vue
              </li>
              <li>
                jQuery
              </li>
              <li>
                Photoshop / Illustrator
              </li>
              <li>
                Agile / JIRA / VSTS
              </li>
              <li>
                Responsive
              </li>
              <li>
                ⭐⭐⭐⭐
              </li>
              <li>
                WebApp
              </li>
              <li>
                Gulp / Webpack
              </li>
              <li>
                GIT / GitLab
              </li>
              <li>
                UX Wireframe
              </li>
              <li>
                SEO
              </li>
              <li>
                MotionDesign
              </li>
              <li>
                Anglais
              </li>
              <li>
                ⭐⭐⭐
              </li>
              <li>
                React
              </li>
              <li>
                Optimisation / Performance
              </li>
              <li>
                CMS Liferay
              </li>
              <li>
                CMS Drupal
              </li>
              <li>
                CMS Wordpress
              </li>
              <li>
                CMS Joomla
              </li>
              <li>
                CMS Sitecore
              </li>
              <li>
                CMS Orchard
              </li>
              <li>
                Gestion de projet / Team Lead
              </li>
              <li>
                ⭐⭐
              </li>
              <li>
                Angular
              </li>
            </ul>

          </div>

          <!-- RIGHT -->
          <div class="uk-width-3-5@m">
            <h2>
              Expérience de travail
            </h2>

            <!-- FREELANCE -->
            <h3 class="uk-margin-remove-top">
              Freelance
            </h3>

            <div class="uk-flex uk-width-1 uk-flex-between">
              <div>
                Thomas Desfossez
              </div>

              <div>
                Décembre 2018 - aujourd'hui
              </div>
            </div>

            <ul class="uk-list">
              <li>
                Mon portfolio <br>

                <span class="uk-text-meta">
                  #VueJs #HTML5 #SCSS #ES6 #JavaScript #Git #MotionDesign
                </span>
              </li>

              <li>
                Exoskills <br>

                <span class="uk-text-meta">
                  #VueJs #HTML5 #SCSS #ES6 #JavaScript #Documentation #Git
                </span>
              </li>

              <li>
                Dyscatalog <br>

                <span class="uk-text-meta">
                  #VueJs #HTML5 #SCSS #Design #Git #Firebase
                </span>
              </li>
            </ul>
            <!-- / FREELANCE -->

            <hr class="uk-divider-icon">

            <!-- NEXIO -->
            <h3 class="uk-margin-remove-top">
              Senior Lead Front-End Web Developer
            </h3>

            <div class="uk-flex uk-width-1 uk-flex-between">
              <div>
                Nexio
              </div>

              <div>
                2017 - 2018
              </div>
            </div>

            <ul class="uk-list">
              <li>
                Nexio <br>

                <span class="uk-text-meta">
                  #VueJs #Sitecore #JSS #SSR #Responsive #HTML5 #SCSS #JavaScript #R&amp;D #Accessibilité #TeamLead
                </span>
              </li>

              <li>
                Fonds de solidarité FTQ <br>

                <span class="uk-text-meta">
                  #PrixBoomerang #Sitecore #Habitat #Agile #Unicorn #Responsive #Bootsrap #HTML5 #SCSS #TypeScript #jQuery #Documentation #Accessibilité #TeamLead #Architecture
                </span>
              </li>

              <li>
                WSP <br>

                <span class="uk-text-meta">
                  #Sitecore #Habitat #Agile #Unicorn #Responsive #Bootsrap #HTML5 #SCSS #jQuery #Documentation #Accessibilité #TeamLead
                </span>
              </li>
            </ul>
            <!-- / NEXIO -->

            <hr class="uk-divider-icon">

            <!-- TINK -->
            <h3 class="uk-margin-remove-top">
              Senior Front-End Web Developer
            </h3>

            <div class="uk-flex uk-width-1 uk-flex-between">
              <div>
                TINK
              </div>

              <div>
                2013 - 2017
              </div>
            </div>

            <ul class="uk-list">
              <li>
                Metro épicerie <br>

                <span class="uk-text-meta">
                  #Responsive #CMS #EnvJava #Agile #SCSS #HTML5 #Accessibilité #TechLead
                </span>
              </li>

              <li>
                Desjardins Courtage En Ligne <br>

                <span class="uk-text-meta">
                  #Responsive #Env.Net #SCSS #HTML5 #Accessibilité
                </span>
              </li>

              <li>
                Tink <br>

                <span class="uk-text-meta">
                  #Responsive #CMS #Drupal #EnvPHP #SCSS #HTML5 #Accessibilité #MotionDesign
                </span>
              </li>

              <li>
                Desjardins Assurances <br>

                <span class="uk-text-meta">
                  #Responsive #CMS #Liferay #Bootstrap #EnvJava #Agile #SCSS #HTML5 #Accessibilité #TechLead
                </span>
              </li>

              <li>
                Desjardins Investisseurs <br>

                <span class="uk-text-meta">
                  #Responsive #Agile #SCSS #HTML5 #Accessibilité #jQuery #TechLead
                </span>
              </li>

              <li>
                Desjardins Monetico <br>

                <span class="uk-text-meta">
                  #PrixBoomerang #Responsive #Agile #CSS3 #HTML5 #Accessibilité #TechLead #MotionDesign
                </span>
              </li>

              <li>
                St-Hubert Rôtisserie <br>

                <span class="uk-text-meta">
                  #PrixBoomerang #Responsive #Agile #CSS3 #HTML5 #jQuery #MotionDesign #TechLead
                </span>
              </li>

              <li>
                Réseau de Transport Métropolitain <br>

                <span class="uk-text-meta">
                  #PrixBoomerang #Responsive #CMS #Orchard #Env.Net #Agile #CSS3 #HTML5 #Accessibilité
                </span>
              </li>

              <li>
                Métro Corpo <br>

                <span class="uk-text-meta">
                  #PrixBoomerang #Responsive #CMS #Drupal #EnvPHP #CSS3 #HTML5
                </span>
              </li>
            </ul>
            <!-- / TINK -->

            <hr class="uk-divider-icon">

            <!-- ALTIMAX -->
            <h3 class="uk-margin-remove-top">
              Web Project Manager
            </h3>

            <div class="uk-flex uk-width-1 uk-flex-between">
              <div>
                Altimax
              </div>

              <div>
                2012 - 2013
              </div>
            </div>

            <ul class="uk-list">
              <li>
                La Plagne Access<br>

                <span class="uk-text-meta">
                  #iOs #Application #TeamManager #ClientManager
                </span>
              </li>

              <li>
                Mavic<br>

                <span class="uk-text-meta">
                  #Responsive #Wireframe #TeamManager #ClientManager
                </span>
              </li>

              <li>
                Somfy<br>

                <span class="uk-text-meta">
                  #Responsive #Wireframe #Joomla #TeamManager #ClientManager
                </span>
              </li>
            </ul>
            <!-- / ALTIMAX -->

            <hr class="uk-divider-icon">

            <!-- CIDMA -->
            <h3 class="uk-margin-remove-top">
              Web Project Manager
            </h3>

            <div class="uk-flex uk-width-1 uk-flex-between">
              <div>
                Cidma
              </div>

              <div>
                2009 - 2012
              </div>
            </div>

            <ul class="uk-list">
              <li>
                + de 30 (obsolètes) projets web B2C<br>

                <span class="uk-text-meta">
                  #CMS #Wordpress #Joomla #WebDeign #HTML5 #CSS3 #SEO #Wireframe #ClientManager #AfterEffect #3DStudioMax
                </span>
              </li>
            </ul>
            <!-- / CIDMA -->

            <hr class="uk-divider-icon">

            <!-- CIDMA -->
            <h3 class="uk-margin-remove-top">
              Freelance - Animateur 3D / Webmaster
            </h3>

            <div class="uk-flex uk-width-1 uk-flex-between">
              <div>
                ConstraintSolver
              </div>

              <div>
                2008 - 2009
              </div>
            </div>

            <ul class="uk-list">
              <li>
                3 sites B2C et une animation 3D<br>

                <span class="uk-text-meta">
                  #3DStudioMax #AfterEffect #Wordpress #Joomla #WebDeign #HTML5 #CSS3 #SEO #Wireframe #ClientManager
                </span>
              </li>
            </ul>
            <!-- / CIDMA -->

            <h2>
              Formations
            </h2>

            <h3 class="uk-margin-remove">
              2019
            </h3>

            <ul class="uk-list">
              <li>
                Service Workies - Progressive Web App
              </li>
              <li>
                Frontend Developer Love Conference - Amsterdam, feb 13th
              </li>
              <li>
                VueJs Conference - Amsterdam, feb 14th &amp; 15th 2019
              </li>
            </ul>

            <h3 class="uk-margin-remove">
              2018
            </h3>

            <ul class="uk-list">
              <li>
                Formation Développement Moderne javascript et ES6, ES7
              </li>
              <li>
                Formation javascript débarque dans votre naviguateur
              </li>
            </ul>

            <h3 class="uk-margin-remove">
              2017
            </h3>

            <ul class="uk-list">
              <li>
                Sitecore® Web Experience Management eLearning
              </li>
            </ul>

            <h3 class="uk-margin-remove">
              2015
            </h3>

            <ul class="uk-list">
              <li>
                Formation Angular Academy
              </li>
            </ul>

            <h3 class="uk-margin-remove">
              2013
            </h3>

            <ul class="uk-list">
              <li>
                Formation Accessibilité
              </li>
            </ul>

            <h3 class="uk-margin-remove">
              2006 - 2009
            </h3>

            <ul class="uk-list">
              <li>
                Haute École Albert jacquard - Namur - Belgique
              </li>
            </ul>

            <h3 class="uk-margin-remove">
              2006 {{hideLayout}}
            </h3>

            <ul class="uk-list">
              <li>
                Bac en Art appliqué avec mention et distinction du Jury
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '../event-bus.js'

export default {
  name: 'cv',
  metaInfo: {
    title: 'CV'
  },
  props: {
    hideLayout: Boolean
  },
  created () {
    EventBus.$emit('hideLayout', this.hideLayout)
  }
}
</script>

<style scoped>
@media print {
  body * {
    font-size: 12px;
  }

  @page {
    size: 297mm 210mm;
    margin: 12mm;
    margin-right: 24mm;
  }
}
</style>
